export default function unloadExternalElement(id: string): void {
  const element = document.getElementById(id);
  if (!element) {
    return;
  }

  element.remove();
}
